import { createApi } from '@reduxjs/toolkit/query/react';
import { createCustomFetchBaseQuery } from '../baseQuery';

export const supportQuestionsApi = createApi({
  reducerPath: 'supportQuestions',
  baseQuery: createCustomFetchBaseQuery(),
  tagTypes: ['SupportQuestions'],

  endpoints: (builder) => ({
    getAllSupportQuestions: builder.query({
      query: ({page,limit , keyword}) => `support-questions?page=${page + 1}&limit=${limit}${keyword ? `&keyword=${keyword}` : ''}`,
      transformResponse: (res) => res,
      providesTags: ['SupportQuestions'],
    }),

    getSupportQuestionById: builder.query({
      query: (id) => `support-questions/${id}`,
      transformResponse: (res) => res.data,
      providesTags: (result, error, id) => [{ type: 'SupportQuestions', id }],
    }),

    addSupportQuestion: builder.mutation({
      query: (data) => ({
        url: 'support-questions',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: data,
      }),
      invalidatesTags: ['SupportQuestions'],
    }),

    updateSupportQuestion: builder.mutation({
      query: ({ id, data }) => ({
        url: `support-questions/${id}`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        'SupportQuestions',
        { type: 'SupportQuestions', id },
      ],
    }),

    deleteSupportQuestion: builder.mutation({
      query: (id) => ({
        url: `support-questions/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [
        'SupportQuestions',
        { type: 'SupportQuestions', id },
      ],
    }),
  }),
});

export const {
  useGetAllSupportQuestionsQuery,
  useGetSupportQuestionByIdQuery,
  useAddSupportQuestionMutation,
  useUpdateSupportQuestionMutation,
  useDeleteSupportQuestionMutation,
} = supportQuestionsApi;
